import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import $http from '$http';
import NProgress from 'nprogress';
import optOpenClassDialog from '@pages/Order/components/optOpenClassDialog/index.vue';
import viewOpenClassDialog from '@pages/Order/components/viewOpenClassDialog/index.vue';
import official from 'official';

export default {
    components: {
        optOpenClassDialog,
        viewOpenClassDialog,
        official
    },
    data() {
        return {
            Session: util.getSessin(),
            queryType: this.$store.state.OutboundStatus,
            queryDelivery: [{ "TypeName": "-请选择-", "TypeValue": "-1" }, { "TypeName": "未发货", "TypeValue": "0" }, { "TypeName": "部分发货", "TypeValue": "1" }, { "TypeName": "全部发货", "TypeValue": "2" }],
            loading2: false,
            lists: [{ "Id": "346567788" }],
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            sels: [], //列表选中列
            SaleCheckView: false,
            pageSizes: [10, 20, 50],
            query: this.getQueryData(),
            childrenId:""
        }
    },
    methods: {
        getQueryData() {
            return cloneDeep({
                c_Name: "",
                AgentName: "",
            });
        },
        //初始化加载页面
        List() {
            this.lists = [];
            this.loading2 = true; //拼命加载中显示
            var para = this.getParams();

            //GET /api/School/GetSchoolApplyByPage
            $http.get('api/School/GetSchoolApplyByPage', para).then(res => {
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    this.totalSize = Cnt;
                    this.loading2 = false; //拼命加载中隐藏
                    this.lists = Data;
                });
            });
        },
        //通用输入参数
        getParams: function() {
            var para = {
                Sid: this.Session[0],
                Session: this.Session[1],
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                orderBy: this.orderBy
            };
            //过滤没有查询的值传入服务器
            for (let item in this.query) {
                let value = this.query[item];
                if (value != '') {
                    para[item] = value;
                }
            }
            return para;
        },
        //通用提示信息
        outTips: function(StateCode, StateMsg, Data, Cnt) {
            if (StateCode !== 0 && StateCode !== 99) {
                this.$notify({
                    title: '错误',
                    message: StateMsg,
                    type: 'error'
                });
            } else {
                this.totalSize = Cnt;
                this.loading2 = false; //拼命加载中隐藏
                this.lists = Data;
            }
        },

        selsChange: function(sels) {
            this.sels = sels;
        },
        //查询
        onQuerySubmit: function() {
            this.pageIndex = 1;
            this.lists = [];
            this.loading2 = true; //拼命加载中显示
            var para = this.getParams()
            this.List();
        }, //查询功能
        handleSizeChange: function(val) {
            this.pageSize = val;
            this.List();
        },
        handleView: function(index, row) {
            this.$refs.refviewOpenClassDialog.show({
                Id: row.Id,
                isReadonly: true
            });
        },
        NewStockOut: function(index, row) {

            this.$refs.refoptOpenClassDialog.show({
                Id: row.Id,
                AgentId: row.AgentId,
                isAdd: true,
                SchoolCome:4
            });
            // this.$refs.myofficial.Regularization({
            //     id: row.Id,
            //     openClass:true
            // });

        }, //编辑功能
        onQueryClean: function() {
            this.query = this.getQueryData();
            this.List();
        },
        //删除
        handleDel: function() {

        },

        handleCurrentChange: function(val) {
            this.pageIndex = val;
            this.List();
        }
    },
    watch: {
        '$route' (to, from) {
            if (this.$route.path == '/Order/startClassApplicationList') {
                this.List();
            }
        }
    },
    mounted() {
        this.List();
    }

}


// WEBPACK FOOTER //
// ./src/pages/Order/startClassApplicationList/vm.js